// @flow
import React from 'react';
import classNames from 'classnames';
import styles from './App.scss';

export const validationClassNameFactory = (buttonState: string) => {
  if (!buttonState) {
    return styles['validation-text'];
  }

  return classNames(styles['validation-text'], styles[buttonState.toLowerCase().replace(/_/g, '-')]);
};

const ValidationText = ({ validationText, buttonState }: { validationText: string, buttonState: string }) =>
  validationText && <p className={validationClassNameFactory(buttonState)}>{validationText}</p>;

export default ValidationText;



// WEBPACK FOOTER //
// ./src/components/ValidationText.js